import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { AccessTimeFilled } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'
import { useHookstate } from '@hookstate/core'
import DispatchTimelineDialog from '~/features/Dispatch/components/DispatchTimeline/components/DispatchTimelineDialog'
interface DispatchTimelineProps {
  readonly canChronology: boolean | undefined
  readonly chronology: number | string | null | undefined
}

export default function DispatchTimeline(props: DispatchTimelineProps) {
  const { translate } = useLang()
  const open = useHookstate(false)

  return (
    <>
      <Grid item>
        <Tooltip
          title={translate('See Chronology')}
          placement="right-start"
          componentsProps={{
            tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
          }}
        >
          <span style={{ display: 'inline-block' }}>
            <IconButton
              disabled={!props.canChronology}
              onClick={() => open.set(true)}
            >
              <AccessTimeFilled />
            </IconButton>
          </span>
        </Tooltip>
      </Grid>
      {open.get() && (
        <DispatchTimelineDialog open={open} chronology={props.chronology} />
      )}
    </>
  )
}
